import Highcharts from 'highcharts';
import ExportingModule from 'highcharts/modules/exporting';
import StockModule from 'highcharts/modules/stock';

ExportingModule(Highcharts);
StockModule(Highcharts);

export default Highcharts;
